var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyFirstPrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint0_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint1_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint2_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint3_radial_592_6620)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint4_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint5_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint6_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint7_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint8_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint9_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint10_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7476 61.4953C53.5833 61.4953 63.4953 48.1768 63.4953 31.7476C63.4953 15.3185 53.5833 2 33.7476 2C13.9119 2 4 15.3185 4 31.7476C4 48.1768 13.9119 61.4953 33.7476 61.4953Z",
    fill: "url(#paint11_radial_592_6620)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    d: "M33.75 50.875C14.625 50.875 14.625 31.75 14.625 31.75H52.875C52.875 31.75 52.875 50.875 33.75 50.875Z",
    fill: "url(#paint12_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Teeth",
    d: "M16.75 33.9375V31.75H50.75V33.9375C50.75 34.4898 50.3023 34.9375 49.75 34.9375H17.75C17.1977 34.9375 16.75 34.4898 16.75 33.9375Z",
    fill: "url(#paint13_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint14_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint15_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint16_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint17_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint18_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint19_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint20_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint21_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint22_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint23_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint24_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint25_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint26_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5097 18.4695C10.7937 23.4138 16.4931 25.579 19.4144 26.415C20.6111 26.7575 21.8668 26.414 22.753 25.5399C25.2891 23.0385 30.4006 17.2986 31.4932 10.745C33.0189 1.59352 21.544 -1.19631 16.9197 6.34653C6.10233 1.26555 0.38004 11.3952 6.5097 18.4695Z",
    fill: "url(#paint27_radial_592_6620)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "#CB0C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint28_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint29_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint30_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint31_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint32_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint33_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint34_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint35_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint36_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9869 18.473C56.705 23.4148 51.0085 25.5792 48.0881 26.415C46.8915 26.7575 45.6358 26.414 44.7497 25.5399C42.2144 23.0392 37.1056 17.302 36.0135 10.7516C34.4884 1.60382 45.9587 -1.18487 50.5811 6.35489C61.3941 1.27598 67.114 11.4015 60.9869 18.473Z",
    fill: "url(#paint37_radial_592_6620)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0383 46.397C61.295 46.1893 60.5224 46.6204 60.3082 47.3673C60.1992 47.7473 59.8028 47.9671 59.4227 47.8581C59.0426 47.7491 58.8229 47.3527 58.9319 46.9726C59.3612 45.4756 60.9123 44.6018 62.4131 45.0151C62.4412 45.022 62.4974 45.0361 62.5482 45.0531C64.6081 45.7397 64.772 48.5348 62.9246 49.5563C62.9245 49.5563 62.9247 49.5562 62.9246 49.5563L58.8181 51.8284C58.4722 52.0199 58.0365 51.8946 57.8451 51.5486C57.6537 51.2027 57.779 50.7671 58.1249 50.5756L62.2314 48.3034C63.0427 47.8549 62.9114 46.6877 62.1001 46.413L62.095 46.4116C62.0859 46.4092 62.075 46.4064 62.0573 46.402C62.051 46.4004 62.0446 46.3987 62.0383 46.397Z",
    fill: "#FFD340"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0383 46.397C61.295 46.1893 60.5224 46.6204 60.3082 47.3673C60.1992 47.7473 59.8028 47.9671 59.4227 47.8581C59.0426 47.7491 58.8229 47.3527 58.9319 46.9726C59.3612 45.4756 60.9123 44.6018 62.4131 45.0151C62.4412 45.022 62.4974 45.0361 62.5482 45.0531C64.6081 45.7397 64.772 48.5348 62.9246 49.5563C62.9245 49.5563 62.9247 49.5562 62.9246 49.5563L58.8181 51.8284C58.4722 52.0199 58.0365 51.8946 57.8451 51.5486C57.6537 51.2027 57.779 50.7671 58.1249 50.5756L62.2314 48.3034C63.0427 47.8549 62.9114 46.6877 62.1001 46.413L62.095 46.4116C62.0859 46.4092 62.075 46.4064 62.0573 46.402C62.051 46.4004 62.0446 46.3987 62.0383 46.397Z",
    fill: "url(#paint38_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0383 46.397C61.295 46.1893 60.5224 46.6204 60.3082 47.3673C60.1992 47.7473 59.8028 47.9671 59.4227 47.8581C59.0426 47.7491 58.8229 47.3527 58.9319 46.9726C59.3612 45.4756 60.9123 44.6018 62.4131 45.0151C62.4412 45.022 62.4974 45.0361 62.5482 45.0531C64.6081 45.7397 64.772 48.5348 62.9246 49.5563C62.9245 49.5563 62.9247 49.5562 62.9246 49.5563L58.8181 51.8284C58.4722 52.0199 58.0365 51.8946 57.8451 51.5486C57.6537 51.2027 57.779 50.7671 58.1249 50.5756L62.2314 48.3034C63.0427 47.8549 62.9114 46.6877 62.1001 46.413L62.095 46.4116C62.0859 46.4092 62.075 46.4064 62.0573 46.402C62.051 46.4004 62.0446 46.3987 62.0383 46.397Z",
    fill: "url(#paint39_radial_592_6620)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9615 45.0151C48.4623 44.6018 50.0135 45.4756 50.4428 46.9726C50.5517 47.3527 50.332 47.7491 49.9519 47.8581C49.5719 47.9671 49.1754 47.7473 49.0664 47.3673C48.8522 46.6204 48.0796 46.1893 47.3363 46.397C47.33 46.3987 47.3236 46.4004 47.3173 46.402C47.2996 46.4064 47.2887 46.4092 47.2796 46.4116L47.2745 46.413C46.4632 46.6877 46.3316 47.8548 47.143 48.3033L51.2497 50.5756C51.5956 50.7671 51.7209 51.2027 51.5295 51.5486C51.3381 51.8946 50.9024 52.0199 50.5565 51.8284L46.4503 49.5564C46.4502 49.5563 46.4504 49.5564 46.4503 49.5564C44.6029 48.5349 44.7665 45.7397 46.8264 45.0531C46.8772 45.0361 46.9335 45.022 46.9615 45.0151Z",
    fill: "#EAA73A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9615 45.0151C48.4623 44.6018 50.0135 45.4756 50.4428 46.9726C50.5517 47.3527 50.332 47.7491 49.9519 47.8581C49.5719 47.9671 49.1754 47.7473 49.0664 47.3673C48.8522 46.6204 48.0796 46.1893 47.3363 46.397C47.33 46.3987 47.3236 46.4004 47.3173 46.402C47.2996 46.4064 47.2887 46.4092 47.2796 46.4116L47.2745 46.413C46.4632 46.6877 46.3316 47.8548 47.143 48.3033L51.2497 50.5756C51.5956 50.7671 51.7209 51.2027 51.5295 51.5486C51.3381 51.8946 50.9024 52.0199 50.5565 51.8284L46.4503 49.5564C46.4502 49.5563 46.4504 49.5564 46.4503 49.5564C44.6029 48.5349 44.7665 45.7397 46.8264 45.0531C46.8772 45.0361 46.9335 45.022 46.9615 45.0151Z",
    fill: "url(#paint40_linear_592_6620)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0671 55.2258V51.739H53.3074V55.2258C53.3074 55.8372 53.0348 56.4239 52.5638 56.8122L50.9774 58.1342H58.3971L56.8107 56.8122C56.3398 56.4156 56.0671 55.8372 56.0671 55.2258Z",
    fill: "url(#paint41_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0671 55.2258V51.739H53.3074V55.2258C53.3074 55.8372 53.0348 56.4239 52.5638 56.8122L50.9774 58.1342H58.3971L56.8107 56.8122C56.3398 56.4156 56.0671 55.8372 56.0671 55.2258Z",
    fill: "url(#paint42_radial_592_6620)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M56.0671 55.2258V51.739H53.3074V55.2258C53.3074 55.8372 53.0348 56.4239 52.5638 56.8122L50.9774 58.1342H58.3971L56.8107 56.8122C56.3398 56.4156 56.0671 55.8372 56.0671 55.2258Z",
    fill: "url(#paint43_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6873 54.4244C51.5062 54.4244 48.9283 51.8465 48.9283 48.6655V42.9974C48.9283 42.6752 49.1927 42.4108 49.515 42.4108H59.8679C60.1901 42.4108 60.4545 42.6752 60.4545 42.9974V48.6655C60.4545 51.8465 57.8766 54.4244 54.6873 54.4244Z",
    fill: "#EA873A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6873 54.4244C51.5062 54.4244 48.9283 51.8465 48.9283 48.6655V42.9974C48.9283 42.6752 49.1927 42.4108 49.515 42.4108H59.8679C60.1901 42.4108 60.4545 42.6752 60.4545 42.9974V48.6655C60.4545 51.8465 57.8766 54.4244 54.6873 54.4244Z",
    fill: "url(#paint44_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6873 54.4244C51.5062 54.4244 48.9283 51.8465 48.9283 48.6655V42.9974C48.9283 42.6752 49.1927 42.4108 49.515 42.4108H59.8679C60.1901 42.4108 60.4545 42.6752 60.4545 42.9974V48.6655C60.4545 51.8465 57.8766 54.4244 54.6873 54.4244Z",
    fill: "url(#paint45_radial_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6873 54.4244C51.5062 54.4244 48.9283 51.8465 48.9283 48.6655V42.9974C48.9283 42.6752 49.1927 42.4108 49.515 42.4108H59.8679C60.1901 42.4108 60.4545 42.6752 60.4545 42.9974V48.6655C60.4545 51.8465 57.8766 54.4244 54.6873 54.4244Z",
    fill: "url(#paint46_radial_592_6620)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4049 58.1343H48.9696C48.3665 58.1343 47.8542 58.5557 47.7385 59.1423L46.4744 65.0004C46.4165 65.2731 46.6231 65.5292 46.904 65.5292H62.4788C62.7597 65.5292 62.9663 65.2731 62.9085 65.0004L61.6443 59.1423C61.5204 58.5557 61.0081 58.1343 60.4049 58.1343Z",
    fill: "url(#paint47_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4049 58.1343H48.9696C48.3665 58.1343 47.8542 58.5557 47.7385 59.1423L46.4744 65.0004C46.4165 65.2731 46.6231 65.5292 46.904 65.5292H62.4788C62.7597 65.5292 62.9663 65.2731 62.9085 65.0004L61.6443 59.1423C61.5204 58.5557 61.0081 58.1343 60.4049 58.1343Z",
    fill: "url(#paint48_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4049 58.1343H48.9696C48.3665 58.1343 47.8542 58.5557 47.7385 59.1423L46.4744 65.0004C46.4165 65.2731 46.6231 65.5292 46.904 65.5292H62.4788C62.7597 65.5292 62.9663 65.2731 62.9085 65.0004L61.6443 59.1423C61.5204 58.5557 61.0081 58.1343 60.4049 58.1343Z",
    fill: "url(#paint49_linear_592_6620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4049 58.1343H48.9696C48.3665 58.1343 47.8542 58.5557 47.7385 59.1423L46.4744 65.0004C46.4165 65.2731 46.6231 65.5292 46.904 65.5292H62.4788C62.7597 65.5292 62.9663 65.2731 62.9085 65.0004L61.6443 59.1423C61.5204 58.5557 61.0081 58.1343 60.4049 58.1343Z",
    fill: "url(#paint50_linear_592_6620)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.9546 60.4841H51.9806C51.6914 60.4841 51.4518 60.7155 51.4518 61.0129V62.5085C51.4518 62.7976 51.6831 63.0373 51.9806 63.0373H56.9546C57.2438 63.0373 57.4834 62.8059 57.4834 62.5085V61.0129C57.4834 60.7237 57.2521 60.4841 56.9546 60.4841Z",
    fill: "#914556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.1742 60.332H52.2002C51.911 60.332 51.6714 60.5634 51.6714 60.8608V62.3564C51.6714 62.6455 51.9027 62.8852 52.2002 62.8852H57.1742C57.4634 62.8852 57.703 62.6538 57.703 62.3564V60.8608C57.703 60.5716 57.4717 60.332 57.1742 60.332Z",
    fill: "url(#paint51_linear_592_6620)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9375 16.875) rotate(132.839) scale(79.6946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9375 16.875) rotate(131.878) scale(82.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.75 24.3125) rotate(101.31) scale(37.924 48.5734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38 27.5) rotate(135) scale(87.1509)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.75 33.875) rotate(77.692) scale(59.8122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8125 32.8125) rotate(55.7131) scale(28.2912 20.5069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3125 36) rotate(9.86581) scale(24.8043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9375 29.625) rotate(43.9708) scale(125.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4713 18.3176) rotate(35.4031) scale(14.6586 7.65559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5635",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1308 10.9585) rotate(57.7713) scale(8.34664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7536",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5147 15.1128) rotate(62.5467) scale(13.0026 8.1652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7536",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1864 16.6979) rotate(49.834) scale(13.6464 8.62809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF7536",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.75 55.125) rotate(-90) scale(23.375 46.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_592_6620",
    x1: 33.75,
    y1: 31.75,
    x2: 33.75,
    y2: 34.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_592_6620",
    x1: 50.7587,
    y1: 4.84238,
    x2: 46.2239,
    y2: 27.9287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA0B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6872 24.5605) rotate(16.6992) scale(10.122 4.52313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6246F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1379 21.0554) rotate(33.5535) scale(9.93332 4.35137)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6246F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.25406 15.4124) rotate(51.7817) scale(12.0229 2.39456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6246F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.37247 15.3746) rotate(58.4957) scale(3.79713 0.921155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41B36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.78779 11.8866) rotate(75.0124) scale(4.09883 0.860393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41B36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4 8.75924) rotate(90) scale(3.13744 0.95238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41B36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.10792 7.13086) rotate(91.2259) scale(5.04438 1.53124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41B36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.20944 6.1104) rotate(116.065) scale(2.51016 0.761965)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41B36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7676 20.1687) rotate(39.4337) scale(8.78764 5.53349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F944A5",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F944A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2564 13.3047) rotate(111.882) scale(9.14045 3.43355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63277",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6273 10.3569) rotate(46.1088) scale(7.69812 4.26577)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.194665,
    stopColor: "#EC6686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3429 7.03754) rotate(107.745) scale(5.59125 4.38943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6385",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9782 5.8395) rotate(71.0992) scale(6.977 1.20412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE2356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE265D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9169 7.70019) rotate(56.0304) scale(7.93132 4.98258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.363657,
    stopColor: "#EC6686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_592_6620",
    x1: 51.1134,
    y1: 8.79926,
    x2: 49.1221,
    y2: 8.4579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.308486,
    stopColor: "#CB0C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB0C4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1098 19.9238) rotate(49.9555) scale(16.054 10.109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F944A5",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F944A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6976 5.69742) rotate(97.2889) scale(5.18618 0.895057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE2356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE265D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1235 13.3101) rotate(130.989) scale(9.75864 3.66578)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63277",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.2409 10.3908) rotate(137.878) scale(5.7956 3.32051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6385",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6302 24.6826) rotate(31.4346) scale(5.92467 2.64749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6246F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0656 20.2585) rotate(45.8212) scale(8.76669 3.84031)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6246F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1864 13.1659) rotate(65.4042) scale(10.9669 2.18425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6246F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2597 19.1591) rotate(117.896) scale(8.35783 7.7968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F944A5",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F944A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_592_6620",
    x1: 60.1228,
    y1: 50.6189,
    x2: 63.1234,
    y2: 47.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC551",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.1554 48.1075) rotate(-21.5519) scale(4.17295 3.84394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72717,
    stopColor: "#FFEC6A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_592_6620",
    x1: 49.6533,
    y1: 47.3247,
    x2: 47.5986,
    y2: 46.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D27840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D27840",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_592_6620",
    x1: 55.7578,
    y1: 57.0766,
    x2: 51.5749,
    y2: 57.0766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB7B3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9902 54.9366) rotate(90) scale(1.72687 1.57504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192585,
    stopColor: "#FFE469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE469",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7721 57.566) rotate(149.162) scale(1.87966 2.85391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD34D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7906 43.3403) rotate(83.702) scale(10.2651 6.59147)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.120527,
    stopColor: "#FFFA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFA73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8568 42.4108) rotate(90) scale(0.581957 6.50384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF45B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF45B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_592_6620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4619 44.683) rotate(121.572) scale(10.8496 10.4093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787409,
    stopColor: "#C55D73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C55D73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_592_6620",
    x1: 46.4644,
    y1: 61.8294,
    x2: 62.915,
    y2: 61.8294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D5B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#955569"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_592_6620",
    x1: 54.6914,
    y1: 65.8503,
    x2: 54.6914,
    y2: 58.1343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199358,
    stopColor: "#8C3A79",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832827,
    stopColor: "#834646",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#834646"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_592_6620",
    x1: 53.1045,
    y1: 61.8318,
    x2: 47.491,
    y2: 60.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.832827,
    stopColor: "#834646",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#834646"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_592_6620",
    x1: 62.2991,
    y1: 62.672,
    x2: 61.5239,
    y2: 62.8529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0817C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0817C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_592_6620",
    x1: 58.0124,
    y1: 61.6086,
    x2: 51.6714,
    y2: 61.6086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBB5B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyFirstPrice);
export default __webpack_public_path__ + "static/media/daily_first_price.708eb154c9d0097826b1c1123ae6522f.svg";
export { ForwardRef as ReactComponent };